export default __webpack_public_path__ + "static/media/les_andelys14.12b838f7.jpg";